import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IOrderNotificationDto } from '../models';
import { IDoorDashKeyDto, IShipDayDto } from '../models/shipday.model';
import { KeyValue } from '@angular/common';

@Injectable()
export class FeatureService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getOrderNotificationDetails(
    id: number
  ): Observable<IOrderNotificationDto> {
    return this.get(`admin/features/${id}`);
  }

  public updateOrderNotificationDetails(
    id: number,
    model: IOrderNotificationDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/features/${id}`, model);
  }

  public getShipDaySettings(id: number): Observable<IShipDayDto> {
    return this.get(`admin/features/shipday/${id}`);
  }

  public getDoorDashSettings(id: number): Observable<IShipDayDto> {
    return this.get(`admin/features/doordash/${id}`);
  }

  public updateShipDaySettings(
    model: IShipDayDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/features/shipday`, model);
  }

  public updateShipDayKey(
    model: KeyValue<number, string>
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/features/shipdayKey`, model);
  }

  public updateDoorDashKey(
    model: IDoorDashKeyDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/features/doordashKey`, model);
  }
}
